import { render, staticRenderFns } from "./CheckField.vue?vue&type=template&id=1af85293&scoped=true&"
import script from "./CheckField.vue?vue&type=script&lang=js&"
export * from "./CheckField.vue?vue&type=script&lang=js&"
import style0 from "./CheckField.vue?vue&type=style&index=0&id=1af85293&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af85293",
  null
  
)

export default component.exports